var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgents = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2a1 1 0 0 1 1 1v1.6h3.2A2.8 2.8 0 0 1 18 7.4v6.8a2.8 2.8 0 0 1-2.8 2.8H6.8A2.8 2.8 0 0 1 4 14.2V7.4a2.8 2.8 0 0 1 2.8-2.8H10V3a1 1 0 0 1 1-1ZM16 5.8H6a.8.8 0 0 0-.8.8v8.4a.8.8 0 0 0 .8.8h10a.8.8 0 0 0 .8-.8V6.6a.8.8 0 0 0-.8-.8ZM8.6 9.2a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Zm4.8 0a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM2.3 9.1a.9.9 0 0 1 .9.9v2.6a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9Zm17.4 0a.9.9 0 0 1 .9.9v2.6a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9ZM8.4 18.2h5.2a.8.8 0 0 1 0 1.6H8.4a.8.8 0 0 1 0-1.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/agents.9ec778c4.svg";
export { ForwardRef as ReactComponent };